var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponent, BaseComponentPlus, cssHelper } from "react-vextensions";
import React from "react";
import { manager } from "../../Manager.js";
import { Observer } from "../Store/MobX.js";
import { Link } from "../ReactComponents/Link.js";
export const subNavBarHeight = 30;
export class SubNavBar_Auto extends BaseComponent {
    render() {
        var _a, _b;
        const { page, filter, ...rest } = this.props;
        const subpages = (_b = (_a = manager.pageTree.children[page]) === null || _a === void 0 ? void 0 : _a.children.VValues()) !== null && _b !== void 0 ? _b : [];
        return (React.createElement(SubNavBar, null, subpages.filter(filter !== null && filter !== void 0 ? filter : (page => true)).map(subpage => {
            return React.createElement(SubNavBarButton, { key: subpage.key, page, subpage: subpage.key, text: subpage.title });
        })));
    }
}
let SubNavBar = class SubNavBar extends BaseComponent {
    render() {
        const { fullWidth, children } = this.props;
        if (!manager.useExpandedNavBar())
            return null; // if sub-nav-bar hidden, subpage selection is handled in project's NavBar.tsx
        const { key, css, dyn } = cssHelper(this);
        return (React.createElement("nav", { className: key("root", "clickThrough"), style: css({
                position: "absolute", zIndex: dyn(manager.zIndexes.subNavBar), top: 0, width: "100%", textAlign: "center",
                // background: "#000 url('/Images/Tiling/TopMenu.png') repeat-x scroll",
                // background: "rgba(0,0,0,.5)", boxShadow: "3px 3px 7px rgba(0,0,0,.07)",
            }) },
            React.createElement("div", { className: key("sub1"), style: css({
                    display: "inline-block",
                    background: manager.GetSkin().OverlayPanelBackgroundColor().css(),
                    boxShadow: manager.GetSkin().NavBarBoxShadow(),
                    color: "rgb(255,255,255)",
                }, dyn(fullWidth ? { width: "100%" } : { borderRadius: "0 0 10px 10px" })) }, children)));
    }
};
SubNavBar = __decorate([
    Observer // in case manager.useExpandedNavBar() uses mobx-getters
], SubNavBar);
export { SubNavBar };
let SubNavBarButton = class SubNavBarButton extends BaseComponentPlus({}, {}) {
    render() {
        var _a, _b;
        const { page, subpage, text, actionFuncIfAlreadyActive, to, style, ...rest } = this.props;
        const currentSubpage = (_a = manager.store.main[page].subpage) !== null && _a !== void 0 ? _a : (_b = manager.pageTree.children[page]) === null || _b === void 0 ? void 0 : _b.DefaultChild;
        const active = subpage == currentSubpage;
        let actionFunc;
        if (to == null) {
            if (!active) {
                actionFunc = s => s["main"][page].subpage = subpage;
            }
            else if (actionFuncIfAlreadyActive) {
                actionFunc = actionFuncIfAlreadyActive;
            }
        }
        const { css } = cssHelper(this);
        return (React.createElement(Link, { ...rest, actionFunc: actionFunc, to: to, text: text, style: css({
                display: "inline-block", cursor: "pointer", verticalAlign: "middle",
                lineHeight: `${subNavBarHeight}px`, color: "rgba(255,255,255,1)", padding: "0 15px", fontSize: 12, textDecoration: "none", opacity: 0.9,
                ":hover": { color: "rgba(100,255,100,1)" },
            }, active && { color: "rgba(100,255,100,1)" }, style) }));
    }
};
SubNavBarButton = __decorate([
    Observer
], SubNavBarButton);
export { SubNavBarButton };
//# sourceMappingURL=SubNavBar.js.map